import {
  faFacebook,
  faInstagram,
  faLinkedinIn,
  faYoutube,
} from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';

import {
  IconStyled,
  SocialNetworkContainer,
} from './SocialNetworksAurea.styles';

const Icon = ({ iconName, link, hasMarginRight }) => (
  <IconStyled
    href={link}
    target="_blank"
    rel="noopener"
    hasMarginRight={hasMarginRight}
  >
    <FontAwesomeIcon icon={iconName} />
  </IconStyled>
);

Icon.propTypes = {
  iconName: PropTypes.object.isRequired,
  link: PropTypes.string.isRequired,
  hasMarginRight: PropTypes.bool,
};

export const SocialNetworksAurea = () => (
  <SocialNetworkContainer>
    <Icon
      iconName={faLinkedinIn}
      link="https://www.linkedin.com/company/%C3%A1urea-sociedade-distribuidora-de-valores-mobili%C3%A1rios-s-a/?viewAsMember=true"
      hasMarginRight
    />
    <Icon
      iconName={faInstagram}
      link="https://www.instagram.com/aurea_ao/"
      hasMarginRight
    />
    <Icon
      iconName={faFacebook}
      link="https://www.facebook.com/people/%C3%81UREA-Sociedade-Distribuidora-de-Valores-Mobili%C3%A1rios-SA/100087812300661/"
      hasMarginRight
    />
    <Icon
      iconName={faYoutube}
      link="https://www.youtube.com/channel/UCIe0abVMiVs8zb0k8XiNrXA"
    />
  </SocialNetworkContainer>
);
